'use strict';
/*
 * Fix for angular bug https://github.com/angular/angular.js/issues/6572
 * Angular fails when you try to use query params with the base URL. It is searching for
 * the base URL at the begining, and because the base URL contains a tailing slash (which is required
 * for things to work in IE8) it won't find a query param in the base URL.
 * The solution to this was to eventually rewrite any URL that comes in with query params to contain
 * a slash before the questionmark before angular is bootstrapped.
 */

(function (window) {
  window.MYSTRENGTH = window.MYSTRENGTH || {};

  function init(url, spa, w) {
    w = w || window;
    var location = w.location.toString();

    var shouldBootstrap = _.includes(location, 'signup') || _.includes(location, 'login');
    var idx = location.indexOf('?');
    if (shouldBootstrap && _.includes(location, url + '?')) {
      // if there's no slash before the question mark, we need to add one
      w.location = location.slice(0, idx) + '/' + location.slice(idx, location.length);
    } else {
      // if (_.includes(location, '#')) {
      //   w.location = location.split('#')[0] + (_.includes(location, url + '?') ? location.slice(idx, location.length) : '');
      // }
      var angularBootstrap = function angularBootstrap() {
        // always go load up the SPA and go to angular routing
        angular.bootstrap(document, [spa], { strictDi: true });

        _.mixin({
          'reverseKeysBy': function reverseKeysBy(obj, comparator) {
            var keys = _.sortBy(_.keys(obj), function (key) {
              return comparator ? comparator(obj[key], key) : key;
            });

            return _.zipObject(keys.reverse(), _.map(keys, function (key) {
              return obj[key];
            }));
          },
          'sortKeysBy': function sortKeysBy(obj, comparator) {
            var keys = _.sortBy(_.keys(obj), function (key) {
              return comparator ? comparator(obj[key], key) : key;
            });

            return _.zipObject(keys, _.map(keys, function (key) {
              return obj[key];
            }));
          }
        });
      };
      // The configuration is hopefully already loaded from scripts, but if not we can load it here
      if (window.MYSTRENGTH.config) {
        angularBootstrap();
      } else {
        //load init config from API in context, assumes jQuery
        window.$.get(window.MYSTRENGTH.API_URL + '/config', function (data) {
          if (data) {
            window.MYSTRENGTH.config = data;
          }
        }).always(angularBootstrap);
      }
    }
  }
  window.MYSTRENGTH.init = init;
})(window);